import axios from 'axios'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function listarChavesPixSicoob(empresaId) {
  const url = `${URL}/empresas/${empresaId}/sicoob/chave-pix`;
  return () => axios.get(url, SLOW_REQUEST_CONFIG);
}
